export const WALLET_CONNECT = 'WALLET_CONNECT';
export const BALANCES = 'BALANCES';